module.exports = __webpack_public_path__ + "static/img/bottom3.5dc8fb20.jpg";